import React, { FC } from "react";
import classNames from "classnames";

import Image from "../../../src/components/Image";
import { XHComponentCommonProps } from "../../types";
import "./index.scss";

export type XHListProps = {
  code: string;
  size?: number;
} & XHComponentCommonProps;

const BANKCARD_URL =
  "https://s.xh1.cn/resources/images/bank/logo-2.0.0/placeholder.png";

const XHBankIcon: FC<XHListProps> = props => {
  const { code, className, size } = props;

  const cls = classNames("xh-bank-icon", className);

  return (
    <Image
      src={BANKCARD_URL.replace("placeholder", code)}
      alt={code}
      width={size}
      height={size}
      className={cls}
    />
  );
};
export default XHBankIcon;
